import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import { backendAPIEndpoint, httpSymbolStoreEndpoint } from '../appConfig'
import { GetTokenResponse } from '../generated/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'PATUsageGuide',
  props: {
    email: null,
    pat: null
  },
  emits: ["done"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'done'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  email: string,
  pat: GetTokenResponse,
}






const howToUseTab = ref(null)
const downloadConfigFileHref = "data:application/json;charset=utf-8," + encodeURI(JSON.stringify({
        'service-url': backendAPIEndpoint,
        'email': props.email,
        'pat': props.pat.token,
      }, null, 2))
const symbolServerDownloadEndpoint = httpSymbolStoreEndpoint.split('://')[0] + "://" + encodeURIComponent(props.email) + ':' + props.pat.token + '@' + httpSymbolStoreEndpoint.split('://')[1]

function copyTextToClipboard(text: string) {
  navigator.clipboard.writeText(text)
}

function done() {
    emit('done')
}


return { __sfc: true,props, emit, howToUseTab, downloadConfigFileHref, symbolServerDownloadEndpoint, copyTextToClipboard, done }
}

})